import filter from 'lodash/filter'
import isEmpty from 'lodash/isEmpty'
import { prismicRichTextAsHTML } from 'prismic-utils'
import { stripTags } from 'supporticon/utils/html'

export const isRichTextEmpty = data =>
  isEmpty(data) || filter(data, item => !!item.text || !!item.url).length === 0

export const isRichText = data => Array.isArray(data)

export const convertToString = data => isRichText(data)
  ? stripTags(prismicRichTextAsHTML(data))
  : data

export const stripHTML = data => stripTags(data, true)

export const replaceLineBreaks = data => {
  const str = data || ''

  return str.replace(/<br ?\/?>/ig, '\n')
}

export const replaceNewLines = data => {
  const str = data || ''

  return str.replace(/(?:\r\n|\r|\n)/g, '<br />')
}

export const getPlainStory = data => stripHTML(replaceLineBreaks(data))

export const getHTMLStory = data => replaceNewLines(data)
